// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog[data-v-ddaba812]{position:relative;background:#2b2b30;border-radius:10px;padding:24px}.dialog .close-modal[data-v-ddaba812]{position:absolute;top:12px;right:12px}@media (min-width:600px){.dialog[data-v-ddaba812]{padding:64px}}", ""]);
// Exports
module.exports = exports;
